module.exports = __webpack_public_path__ + "static/media/about.c6eb497a.jpg";